export default "\n<h1>you are here</h1>\n<div class=\"dot\"></div>\n"